import React, { useEffect } from 'react'
import { DetailsSvg } from '../../shared/SVG/iconSvg'
import { GetHistoryOfImportantEntities } from '../../api/requestAxios/userActivities'
import moment from "moment-jalaali";
import { enToPersianChar } from './index';

const Columns = ({ setColumns, setStates }) => {

    const activityCompo = ({ item }) => {
        return (<div>
            {item.url}
        </div>)
    }
    const dateCompo = ({ item }) => {
        if (item.requestTime) {
            const date = item.requestTime.split('T')[0]
            const time = item.requestTime.split('T')[1].split('.')[0]
            const momentDate = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').local('fa').format('jYYYY/jMM/jDD،HH:mm')

            return (<div>{enToPersianChar(momentDate)}</div>)
        } else {
            return (<div>----</div>)
        }

    }
    const detailCompo = ({ item }) => {
        const getDetail = async () => {
            setStates({ getDetailPending: true, displayDetail: true })
            const response = await GetHistoryOfImportantEntities(item.requestId)
            setStates({ getDetailPending: false, details: response.data })
        }

        return (<div>
            <span onClick={() => getDetail()}><DetailsSvg /></span>
        </div>)
    }

    useEffect(() => {
        setColumns([
            { title: 'ردیف', property: 'rowNumber', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            { title: 'کاربر', property: 'nameAndFamily', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            { title: 'IP', property: 'ip', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            // { title: 'ایمیل کاربر', property: 'email', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            { title: 'فعالیت', property: '', component: activityCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
            // { title: 'مشترک', property: 'customerNameAndFamily', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            // { title: 'ایمیل مشترک', property: 'customerEmail', filterProperty: null, hasSort: false, hasFilter: false, display: true },
            { title: 'زمان فعالیت', property: '', component: dateCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
            { title: 'جزئیات', property: '', component: detailCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },



        ]
        )
    }, [])
    return ('')
}

export default Columns
